import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { HomeComponent } from './home/home.component';
// import { InvoiceComponent } from './invoice/invoice.component';
import { LayoutComponent } from './layout/layout.component';
import { authGuard } from './guards/auth.guard';
// import { EwoComponent } from './ewo/ewo.component';
import { ProjectComponent } from './project/project.component';
import { RequestComponent } from './request/request.component';
import { CreateProjectComponent } from './create-project/create-project.component';
// import { CreateInvoiceComponent } from './create-invoice/create-invoice.component';
// import { CreateEwoComponent } from './create-ewo/create-ewo.component';
import { CreateRequestComponent } from './create-request/create-request.component';
import { EditRolesComponent } from './edit-roles/edit-roles.component';
import { AccountComponent } from './account/account.component';
import { TimesheetComponent } from './timesheet/timesheet.component';
import { TimesheetReportComponent } from './timesheet-report/timesheet-report.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { AddNewUserComponent } from './add-new-user/add-new-user.component';
import { CustomerSelectionComponent } from './customer-selection/customer-selection.component';
import {
  customerContextGuard,
  customerSelectionGuard,
  writeAccessGuard
} from './guards/customer-context.guard';

export const routes: Routes = [
  { 
    path: 'login', 
    component: LoginComponent 
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'customers',
    component: CustomerSelectionComponent,
    canActivate: [() => authGuard(), () => customerSelectionGuard()]
  },
  { 
    path: '', 
    component: LayoutComponent,
    canActivate: [() => authGuard(), () => customerContextGuard()],
    children: [
      { path: '', pathMatch: 'full', component: HomeComponent },
      { path: 'projects', component: ProjectComponent },
      // { path: 'invoices', component: InvoiceComponent },
      // { path: 'ewos', component: EwoComponent},
      { path: 'requests', component: RequestComponent },
      { path: 'projects/create', component: CreateProjectComponent, canActivate: [() => writeAccessGuard()] },
      // { path: 'invoices/create', component: CreateInvoiceComponent },
      // { path: 'ewos/create', component: CreateEwoComponent },
      { path: 'requests/create', component: CreateRequestComponent, canActivate: [() => writeAccessGuard()] },
      { path: 'roles/edit', component: EditRolesComponent, canActivate: [() => writeAccessGuard()] },
      { path: 'account', component: AccountComponent },
      { path: 'timesheet', component: TimesheetComponent },
      { path: 'timesheet/report', component: TimesheetReportComponent },
      { path: 'user-profile/:id', component: UserProfileComponent },
      { path: 'user/add', component: AddNewUserComponent, canActivate: [() => writeAccessGuard()] }
    ]
  },
  { 
    path: '**', 
    redirectTo: '' 
  }
];
